/**
 * Field-name and timing constants shared by the form guard ladder.
 *
 * Split out from `lib/abuse.ts` on purpose: a later task (BotID verdict via
 * `botid/server`) makes `lib/abuse.ts` server-only, but a client form
 * component still needs these exact literals to render the honeypot input
 * and stamp the elapsed-time field. This file must stay free of imports (no
 * server-only packages, no Node APIs) so it is safe to pull into client
 * bundles. `lib/abuse.ts` imports these for its own internal use only — it
 * must never re-export them. Client code always imports directly from
 * `./abuse-fields`.
 */

/** How long a submission must take before we stop suspecting a bot. */
export const MIN_ELAPSED_MS = 2_000;

/** Reserved names the guard owns. Never put these in a route's field spec. */
export const HONEYPOT_FIELD = 'rii_hp';
export const ELAPSED_FIELD = 'elapsedMs';
export const TURNSTILE_FIELD = 'turnstileToken';
